import { render, staticRenderFns } from "./copyingDetail.vue?vue&type=template&id=b51840ce&scoped=true&"
import script from "./copyingDetail.vue?vue&type=script&lang=js&"
export * from "./copyingDetail.vue?vue&type=script&lang=js&"
import style0 from "./copyingDetail.vue?vue&type=style&index=0&id=b51840ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51840ce",
  null
  
)

export default component.exports